import { ECategory } from '../../../types/share';

export function getPriceTitle(category: ECategory) {
  const categoryLowerCase = category.toLowerCase();

  const isCommercial = categoryLowerCase.includes('commercial');
  const isSuburban = categoryLowerCase.includes('suburban');
  const isRent = categoryLowerCase.includes('rent');

  if (isRent) {
    return isCommercial || isSuburban ? 'Средняя арендная ставка м²' : 'Средняя арендная ставка';
  }

  return 'Средняя цена м²';
}
